<script>
import { getIconPath as getImgPath } from "@/utils/getCorrectPath";

export default {
  name: "SubscriptionCancelConfirmModal2",

  data() {
    return {
      getImgPath: getImgPath,
    };
  },

  computed: {
    benefits() {
      return [
        {
          icon: "save-costs",
          label: this.$t("account.pauseBenefits.saveCosts.label"),
          text: this.$t("account.pauseBenefits.saveCosts.text"),
        },
        {
          icon: "keep-your-data",
          label: this.$t("account.pauseBenefits.keepYourData.label"),
          text: this.$t("account.pauseBenefits.keepYourData.text"),
        },
        {
          icon: "flexibility",
          label: this.$t("account.pauseBenefits.flexibility.label"),
          text: this.$t("account.pauseBenefits.flexibility.text"),
        },
      ];
    },
  },
};
</script>

<template>
  <div class="step-block">
    <div class="subtitle">{{ $t("account.suggestPause") }}</div>

    <h6 class="title">{{ $t("account.benefitsOfPausing") }}</h6>
    <div v-for="(benefit, index) in benefits" :key="index" class="item">
      <img
        v-if="getImgPath(benefit.icon)"
        :src="getImgPath(benefit.icon)"
        class="item-icon"
        alt="icon"
      />

      <div class="item-content">
        <div class="item-title">
          {{ benefit.label }}
        </div>

        <div class="item-text">
          {{ benefit.text }}
        </div>
      </div>
    </div>

    <div class="text-content">
      {{ $t("account.cancelAccessWarning") }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.step-block {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .item {
    display: flex;
    gap: 8px;
    align-items: center;
    border: 1px solid #dfdfdf;
    border-radius: 6px;
    padding: 8px;

    .item-title {
      font-family: Inter;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0px;
      vertical-align: bottom;
    }

    .item-text {
      font-family: Inter;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0px;
      vertical-align: bottom;
    }
  }
}

.subtitle {
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  vertical-align: bottom;
}

.title {
  font-family: Inter;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  vertical-align: bottom;
}

.text-content {
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  vertical-align: bottom;
}
</style>
